<template>
	<div class="md-layout">
		<div class="md-layout-item md-size-66">
			<form ref="insect_edit" @submit.prevent="updateInsect">
				<md-card>
					<md-card-header class="md-card-header-icon md-card-header-blue">
						<div class="card-icon">
							<md-icon>edit</md-icon>
						</div>
						<h4 class="title">Modification d'un insecte</h4>
					</md-card-header>
					<insect-form :insect="insect" :errors="errors"></insect-form>
					<md-card-actions md-alignment="left">
						<md-button type="submit" class="md-success">
							Enregistrer
						</md-button>
						<md-button class="md-warning"
								   @click="goBack">
							Retour
						</md-button>
					</md-card-actions>
				</md-card>
			</form>
		</div>
	</div>
</template>

<script>
import InsectForm from "@/pages/Configuration/Insects/InsectForm";
export default {
	name: "InsectEdit",
	components: {
		InsectForm
	},
	data() {
		return {
			insect: {
				name: '',
				isActive: null,
                path: null,
				url: ''
			},
			errors: [],
		}
	},
	methods: {
		async getInsectDetails() {
			const { data } = await this.$store.dispatch('insects/getInsectDetails', this.$route.params.id)
			this.insect = {
				...data,
				isActive: !!data.is_active
			}
		},
		async updateInsect() {
			if (this.insect.file) {
				let formData = new FormData()
				formData.append('file', this.insect.file)
				formData.append('fileName', this.formatFileName(this.insect.file))
				try {
					await this.$store.dispatch('insects/deleteStorageInsect', this.insect.id)
					const { data } = await this.$store.dispatch('insects/uploadInsect', formData)
					let pathParts = data.split('/')
					this.insect.path = pathParts[3]
				} catch (e) {
					this.errors = e.response.data.errors
				}
			}
			try {
				await this.$store.dispatch('insects/updateInsect', this.insect)
				await this.$store.dispatch("alerts/success", "Insecte modifié")
				this.goBack()
			} catch (e) {
				this.errors = e.response.data.errors
			}
		},
		formatFileName(file) {
			let regex = /[ ]|'/g // search space and apostrophe
			return Math.floor(Math.random() * (9999 - 1000 + 1) + 1000) + '-' +
				file.name.toLowerCase().replaceAll(regex, '-')
		},
		goBack() {
			this.$router.go(-1)
		}
	},
	mounted() {
		this.getInsectDetails()
	}
}
</script>

<style scoped>

</style>
